module.exports = __webpack_public_path__ + "static/media/shaws.01cedd04.svg";